import { useEffect } from "react";

const DynamicFavicon = () => {
  useEffect(() => {
    const lightFavicon = "cxLogos/cxLogoWhite.svg";
    const darkFavicon = "cxLogos/cxLogo.svg";

    const updateFavicon = (isDarkMode) => {
      const link = document.querySelector("link[rel='icon']");
      if (link) {
        link.href = isDarkMode ? lightFavicon : darkFavicon;
      }
    };

    const darkModeMediaQuery = window.matchMedia(
      "(prefers-color-scheme: dark)"
    );

    updateFavicon(darkModeMediaQuery.matches);

    const handleChange = (event) => updateFavicon(event.matches);

    darkModeMediaQuery.addEventListener("change", handleChange);

    return () => {
      darkModeMediaQuery.removeEventListener("change", handleChange);
    };
  }, []);

  return null;
};

export default DynamicFavicon;
